import React from "react";
import logo from "../img/logo.png"; // adjust the path based on your structure

const Landing_div = () => {
  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <div
        style={{
          width: "100%",
          margin: "0 auto",
          maxHeight: "400px",
          overflowY: "auto",
          border: "0px solid black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "300px", // ensure it has height for vertical centering
        }}
      >
        <img
          src={logo}
          alt="App Logo"
          style={{
            maxHeight: "100%",
            maxWidth: "100%",
            objectFit: "contain",
          }}
        />
      </div>
    </div>
  );
};

export default Landing_div;
